import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import { useIsMobile } from "~helpers/hooks/useIsMobile";

const NumbersAndMinutesScreen = () => {
  const isMobile = useIsMobile();

  const numbersCost = [
    {
      title: 'Городской',
      cost: '342',
      icon: `${process.env.PUBLIC_DIR}/images/phone-small-green-icon.svg`
    },
    {
      title: 'Мобильный',
      cost: '290',
      icon: `${process.env.PUBLIC_DIR}/images/smartphone-small-green-icon.svg`
    },
    {
      title: 'Номер 8-800',
      cost: '990',
      icon: `${process.env.PUBLIC_DIR}/images/map-small-green-icon.svg`
    }
  ]

  return (
    <Screen
      id='phone_numbers'
      title={<span><StyledScreen.GreenText>Номера</StyledScreen.GreenText> и минуты</span>}
      subTitle={<span>от наших партнеров <a href="https://bmi-telecom.ru/" target='_blank'>BMI Telecom</a> и <a href="https://voximplant.ru/" target='_blank'>VoxImplant</a></span>}
    >
      <Styled.Container>
        <Styled.Left>
          <Styled.IconWrapp>
            <Styled.IconBg />
            <Styled.IconPlace>
              Звонки<br/>
              от <Styled.IconPlaceCost>1,50 ₽</Styled.IconPlaceCost>/мин
            </Styled.IconPlace>
          </Styled.IconWrapp>
        </Styled.Left>
        <Styled.Right>
          <Styled.ListTitle>Преимущества покупки номера через<br/>onlinepbx:</Styled.ListTitle>
          <Styled.List>
            <Styled.ListItem>Цены ниже, чем при покупке<br />у оператора связи напрямую</Styled.ListItem>
            <Styled.ListItem>Ускоренная верификация</Styled.ListItem>
            <Styled.ListItem>Продаем номера физ. лицам</Styled.ListItem>
            <Styled.ListItem>Прием sms-сообщений</Styled.ListItem>
            <Styled.ListItem>Пакеты минут</Styled.ListItem>
            <Styled.ListItem>FMC SIM-карты от 550 руб.</Styled.ListItem>
          </Styled.List>
        </Styled.Right>
      </Styled.Container>
      <Styled.CostContainer>
        {
          numbersCost.map((num: any) => (
            <Styled.CostCol>
              <Styled.CostHeader>
                <Styled.CostIcon>
                  <img src={num.icon} alt={num.title} />
                </Styled.CostIcon>
                <Styled.CostTitle>{num.title}</Styled.CostTitle>
              </Styled.CostHeader>
              <Styled.CostBody>
                <Styled.CostFromText>от</Styled.CostFromText>
                <Styled.CostText>{num.cost}</Styled.CostText>
                <Styled.CostUnitsText>руб.<br />в месяц</Styled.CostUnitsText>
              </Styled.CostBody>
            </Styled.CostCol>
          ))
        }
      </Styled.CostContainer>
      <Styled.NoteBlock>
        <Styled.NoteTitle>Уже есть номер?</Styled.NoteTitle>
        <Styled.NoteText>Приходите со своим номером — мы бесплатно подключим и настроим любое количество номеров.</Styled.NoteText>
      </Styled.NoteBlock>
    </Screen>
  )
}

export { NumbersAndMinutesScreen }
